export const AVAILABLE_LANGUAGES = [
    "es", "en", "gl"
];

export const LANGUAGE_BY_DEFAULT = "es";

export const LANGUAGE_TRANSLATION_KEY = "languages"